<template>
  <div class="c-employee">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Employee list (now shown {{currentCount}})
              <v-spacer></v-spacer>
              <v-btn
                text
                small
                :color="showEmployeeOn.regular ? 'primary' : 'var(--v-theme-on-surface)'"
                @click="showEmployeeOnly('regular')"
              >
                Regular Employee - {{regularEmployee.length}}
              </v-btn>
              /
              <v-btn
                text
                small
                :color="showEmployeeOn.contractor ? 'primary' : 'var(--v-theme-on-surface)'"
                @click="showEmployeeOnly('contractor')"
              >
                Contractors - {{contractors.length}}
              </v-btn>
              /
              <v-btn
                text
                small
                :color="showEmployeeOn.trialPeriod ? 'primary' : 'var(--v-theme-on-surface)'"
                @click="showEmployeeOnly('trialPeriod')"
              >
                On trial period - {{employeeOnTrialPeriod.length}}
              </v-btn>
              /
              <v-btn
                text
                small
                color="grey darken-1"
                @click="showMoreStatistic = !showMoreStatistic"
              >
                show more statistic... {{this.$route.params.slug}}
              </v-btn>
              <v-spacer></v-spacer>
              <v-text-field
                dense
                hide-details
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
              ></v-text-field>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-data-table
                ref="employee_table"
                dense
                class="data-table"
                fixed-header
                :height="tableHeight"
                :headers="headers"
                :items="employee"
                :items-per-page="itemsPerPage"
                :search="search"
                :custom-filter="customFilter"
                :footer-props="{
                  'items-per-page-options': [10, 30, 50, -1]
                }"
                mobile-breakpoint="0"
                @click:row="onRowClick"
                @update:page="goTo"
                @pagination="updateCurrentCount"
              >
                <!-- Items -->
                <template v-slot:[`item`]='{ item }'>
                  <tr
                    :class="{
                      'red lighten-5': item.Is_Deleted && !$vuetify.theme.dark,
                      'orange lighten-5': (item.Left_Date && +(new Date(item.Left_Date)) < +(new Date())) && !item.Is_Deleted && !$vuetify.theme.dark,

                      'red': item.Is_Deleted && $vuetify.theme.dark,
                      'blue lighten-1': (item.Left_Date && +(new Date(item.Left_Date)) < +(new Date())) && !item.Is_Deleted && $vuetify.theme.dark
                    }"
                    @click.prevent="onRowClick(item)"
                  >
                    <td class="v-data-table__divider px-2 text-no-wrap" v-for="(key, itemKey) in headers" :key="itemKey">
                      <span v-if="['Status_From_Date', 'Birth'].indexOf(key.value) > -1">
                        {{ item[key.value] | dateFilter }}
                      </span>
                      <span v-else-if="key.value === 'Status'">
                        {{ item[key.value] === 'Status error' ? '' : item[key.value] }}
                      </span>
                      <span v-else-if="key.value === 'Supervisor_Full_Name'">
                        {{ item[key.value] === '[ ]' ? '' : item[key.value] }}
                      </span>
                      <span v-else-if="key.value === 'Mentor_Full_Name'">
                        {{ item[key.value] === '[ ]' ? '' : item[key.value] }}
                      </span>
                      <span v-else>{{ item[key.value] }}</span>
                    </td>
                  </tr>
                  <tr
                    :class="{
                      'red lighten-4': item.Is_Deleted && !$vuetify.theme.dark,
                      'red lighten-1': item.Is_Deleted && $vuetify.theme.dark
                    }"
                    v-if="item.Is_Deleted"
                    @click.prevent="onRowClick(item)"
                  >
                    <td :colspan="headers.length" class="px-2 text-no-wrap">{{ item.Deleted_Notes }}</td>
                  </tr>
                </template>
                <!-- /Items -->
                <!-- Footer -->
                <template v-slot:[`footer`]>
                  <v-row class="py-2">
                    <v-col cols="auto" class="d-flex">
                      <v-switch
                        class="my-0"
                        v-model="showCurrentEmployee"
                        label="Current employees"
                        color="primary"
                        hide-details
                        >
                        </v-switch>
                      <v-switch
                      class="my-0 ml-3"
                      v-model="showTerminated"
                      label="Show terminated"
                      color="primary"
                      hide-details>
                      </v-switch>
                      <v-switch
                      class="my-0 ml-3"
                      v-model="showDeleted"
                      label="Show deleted"
                      color="primary"
                      hide-details
                      ></v-switch>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="auto" v-if="canAddNew && !officeManager && !executiveAssistant">
                      <v-btn
                        v-if="canExportEmployeeInfo"
                        color="primary"
                        small
                        outlined
                        class="mr-2"
                        @click.prevent="importMilitaryInfoFromXLSX"
                      >Import Military Info</v-btn>

                      <v-btn
                        v-if="canExportEmployeeInfo"
                        color="primary"
                        small
                        outlined
                        class="mr-2"
                        @click.prevent="exportMilitaryInfoToXLSX"
                      >Export Military Info</v-btn>

                      <v-btn
                        v-if="canExportEmployeeInfo"
                        color="primary"
                        small
                        outlined
                        @click.prevent="exportToXLSX"
                      >Export to XLSX</v-btn>

                      <v-btn
                        class="ml-3"
                        color="success"
                        small
                        @click.prevent="addNewEmployee"
                      >Create new</v-btn>
                    </v-col>
                  </v-row>
                </template>
                <!-- /Footer -->
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <input type="file" ref="militaryFileInput" style="display: none" accept=".xlsx, .xls" @change="handleFileUpload" />

    <v-dialog
      v-model="importLogDialog"
      max-width="800px"
      scrollable>
      <v-card>
        <v-card-title class="headline">
          Import Military Info - Log
          <v-spacer></v-spacer>
          <v-btn icon @click="importLogDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Row</th>
                <th>Field</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(log, idx) in importLogs" :key="idx">
                <td>{{ log.row }}</td>
                <td class="red--text font-weight-bold">{{ log.field }}</td>
                <td>{{ log.reason }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="importLogDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      max-width="550px"
      width="90%"
      v-model="showMoreStatistic"
      >
      <v-card>
        <v-card-title>
          Count of employee by position
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row class="pt-4">
            <v-col cols="12" sm="6" md="4"
              class="py-1"
              v-for="(count, status) of statistic"
               :key="status"
               >
              {{ status === 'null' ? 'Without Position' : status }} - {{ count }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="showMoreStatistic = !showMoreStatistic">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <EmployeeDetails
      v-if="showDetails"
      v-model="showDetails"
      :employee="selectedEmployee"
      :edit="editEmployee"
      :key="`employee_${selectedEmployee ? selectedEmployee.Employee_ID : 'no_id'}_${detailsUpdateKey}`"
      @closeDetails="onCloseDetails"
      @createNewEmployee="createNewEmployee"
      @updateEmployee="updateEmployee"
    />
  </div>
</template>
<script>
const xlsxExport = require('json-as-xlsx')

export default {
  name: 'Employee',
  components: {
    EmployeeDetails: () => import('@/components/employee/EmployeeDetails.vue')
  },
  data () {
    return {
      search: '',
      showDeleted: false,
      showTerminated: false,
      showCurrentEmployee: true,
      showDetails: false,
      selectedEmployee: null,
      oldLogin: '',
      detailsUpdateKey: 0,
      currentCount: 0,
      editEmployee: false,
      showMoreStatistic: false,
      showEmployeeOn: {
        trialPeriod: false,
        regular: false,
        contractor: false
      },
      currentItemsPerPage: 50,
      importLogDialog: false,
      importLogs: []
    }
  },
  computed: {
    allFilterableKeys () {
      return ['Name', 'Last_Name', 'Full_Name', 'Status', 'Supervisor_Full_Name', 'Mentor_Full_Name', 'Department', 'Contract_Type', 'Work_Location_Type',
        'Hiring_Date', 'End_Of_Trial_Period_Date', 'Left_Date']
    },
    itemsPerPage: {
      get () {
        return this.currentItemsPerPage
      },
      set (val) {
        this.currentItemsPerPage = val
      }
    },
    employeeRoles () {
      return this.$store.getters.getEmployeeRoles
    },
    headers () {
      const headers = [
        {
          text: 'First name',
          value: 'Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: true
        },
        {
          text: 'Last name',
          value: 'Last_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: true
        },
        {
          text: 'Position',
          value: 'Status',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: true
        },
        {
          text: 'Supervisor',
          value: 'Supervisor_Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: true
        },
        {
          text: 'Mentor',
          value: 'Mentor_Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: true
        },
        {
          text: 'Department',
          value: 'Department',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: true
        },
        {
          text: 'Contract Type',
          value: 'Contract_Type',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: true
        },
        {
          text: 'Work Location',
          value: 'Work_Location_Type',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: true
        },
        {
          text: 'Hiring Date',
          value: 'Hiring_Date',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: true
        },
        {
          text: 'End Of Trial Period',
          value: 'End_Of_Trial_Period_Date',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: this.employeeRoles.financier.val || this.employeeRoles.hr.val
        },
        {
          text: 'Left Date',
          value: 'Left_Date',
          divider: true,
          class: 'px-2 text-no-wrap',
          width: '25%',
          show: this.employeeRoles.financier.val || this.employeeRoles.hr.val
        }
      ]
      return headers.filter(item => item.show)
    },
    tableHeight () {
      const windowW = window.innerWidth
      return windowW < 768 ? 'calc(100vh - 280px)' : 'calc(100vh - 290px)'
    },
    contractTypes () {
      return this.$store.getters.getContractTypes
    },
    departments () {
      return this.$store.getters.getDepartments
    },
    workLocations () {
      return this.$store.getters.getWorkLocations
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    user () {
      return this.$store.getters.getUser
    },
    currentUserStatus () {
      return this.$store.getters.getAllEmployee.find(el => el.Employee_ID === this.user.employee_id).Status
    },
    contractors () {
      return this.$store.getters.getAllEmployee.filter(item => {
        const isCurrentEmployee = !this.showCurrentEmployee && !item.Left_Date && !item.Is_Deleted
        const isDeleted = !this.showDeleted && item.Is_Deleted
        const leftDate = !this.showTerminated && item.Left_Date && new Date(item.Left_Date) < new Date()
        const isContractor = item.Contract_Type_Code === 'CONTRACTOR'
        return !isCurrentEmployee && !isDeleted && !leftDate && isContractor
      })
    },
    regularEmployee () {
      return this.$store.getters.getAllEmployee.filter(item => {
        const isCurrentEmployee = !this.showCurrentEmployee && !item.Left_Date && !item.Is_Deleted
        const isDeleted = !this.showDeleted && item.Is_Deleted
        const leftDate = !this.showTerminated && item.Left_Date && new Date(item.Left_Date) < new Date()
        const isContractor = item.Contract_Type_Code === 'CONTRACTOR'
        return !isCurrentEmployee && !isDeleted && !leftDate && !isContractor
      })
    },
    employeeOnTrialPeriod () {
      const d = new Date()
      return this.$store.getters.getAllEmployee.filter(item => {
        const isCurrentEmployee = !this.showCurrentEmployee && !item.Left_Date && !item.Is_Deleted
        const isDeleted = !this.showDeleted && item.Is_Deleted
        const leftDate = !this.showTerminated && item.Left_Date
        if (item.End_Of_Trial_Period_Date) {
          return !isCurrentEmployee && !isDeleted && !leftDate && +d < +(new Date(item.End_Of_Trial_Period_Date))
        }
      })
    },
    employee () {
      let empl = this.$store.getters.getAllEmployee

      if (this.showEmployeeOn.regular) {
        empl = this.regularEmployee
      } else if (this.showEmployeeOn.contractor) {
        empl = this.contractors
      } else if (this.showEmployeeOn.trialPeriod) {
        empl = this.employeeOnTrialPeriod
      }

      empl = empl.filter(item => {
        if (!this.showCurrentEmployee && !item.Is_Deleted && !item.Left_Date) {
          return false
        }

        if (!this.showDeleted && item.Is_Deleted) {
          return false
        }

        // Exclude only employees with past Left_Date, not future dates
        if (!this.showTerminated && item.Left_Date && new Date(item.Left_Date) < new Date()) {
          return false
        }

        return true
      })
      return empl
    },
    canAddNew () {
      return this.employeeRoles && (
        (this.employeeRoles.hr && this.employeeRoles.hr.val) ||
        (this.employeeRoles.financier && this.employeeRoles.financier.val)
      )
    },
    canExportEmployeeInfo () {
      return this.employeeRoles && (
        (this.employeeRoles.financier && this.employeeRoles.financier.val) ||
        (this.employeeRoles.hr && this.employeeRoles.hr.val))
    },
    canExportXLSXEmployee () {
      return this.employeeRoles && (
        (this.employeeRoles.financier && this.employeeRoles.financier.val))
    },
    employeeList () {
      return this.$store.getters.getEmployee
    },
    statistic () {
      const empl = this.$store.getters.getAllEmployee.filter(item => !item.Is_Deleted && !item.Left_Date)
      const res = {}
      for (let i = 0; i < empl.length; i++) {
        const status = empl[i].Status
        if (res[status]) continue
        res[status] = empl.filter(item => item.Status === status).length
      }
      // Return sorted object
      return Object.keys(res).sort().reduce(
        (obj, key) => {
          obj[key] = res[key]
          return obj
        },
        {}
      )
    },
    officeManager () {
      const position = this.$store.getters.getCurrentUserPosition
      return position === 'Office Manager'
    },
    executiveAssistant () {
      const position = this.$store.getters.getCurrentUserPosition
      return position === 'Executive Assistant'
    }
  },
  async mounted () {
    await this.getPermissions()
    this.getEmployee()
    this.getStatuses()
    this.getUserPosition()
    if (!this.contractTypes.length) this.getContractTypes()
    if (!this.departments.length) this.getDepartments()
    if (!this.employeeList.length) this.getEmployeeList()
    if (this.$route.params.Employee_ID) this.getEmployeeDetails(this.$route.params.Employee_ID)
    if (!this.workLocations.length) this.getWorkLocations()
    this.$store.watch(
      (state) => state.employeeNameClicked,
      () => { this.getEmployeeDetails(this.user.employee_id) },
      { deep: false }
    )
  },
  methods: {
    importMilitaryInfoFromXLSX () {
      this.$refs.militaryFileInput.click()
    },
    handleFileUpload (event) {
      const file = event.target.files[0]
      if (!file) return

      const formData = new FormData()
      formData.append('File', file)

      this.axios.post('/api/import_employee_military_info', formData, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const { rowsAffected, logs } = res.data
        this.importLogs = logs || []

        if (rowsAffected > 0) {
          this.$store.dispatch('setSuccess', {
            successMsg: `Import complete. ${rowsAffected} records processed.`
          })
          this.getEmployee()
        } else {
          this.$store.dispatch('setError', {
            errorMsg: 'No records were updated.'
          })
        }

        if (this.importLogs.length > 0) {
          this.importLogDialog = true
        }
      }).catch(error => {
        const errorMsg =
          (error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : error.message

        this.$store.dispatch('setError', {
          errorMsg: 'Import error: ' + errorMsg
        })
      }).finally(() => {
        event.target.value = ''
      })
    },
    customFilter (value, search, item) {
      if (!search) return true

      const lowerSearch = search.toLowerCase()

      return this.allFilterableKeys.some(key => {
        const fieldValue = item[key]
        return fieldValue && fieldValue.toString().toLowerCase().includes(lowerSearch)
      })
    },
    exportToXLSX () {
      const body = {
        withSalary: this.employeeRoles.financier.val
      }
      this.axios.post('/api/get_employee_data_for_xlsx', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const columns = [
          {
            label: 'Login',
            value: 'Login'
          },
          {
            label: 'Full Name',
            value: 'Full_Name'
          },
          {
            label: 'Name UA',
            value: 'Name_UA'
          },
          {
            label: 'Last Name UA',
            value: 'Last_Name_UA'
          },
          {
            label: 'City',
            value: 'City_UA'
          },
          {
            label: 'Country',
            value: 'Address_UA'
          },
          {
            label: 'Cellular',
            value: 'Cellular'
          },
          {
            label: 'Email',
            value: 'e_mail'
          },
          {
            label: 'Public Notes',
            value: row => {
              let res = ''
              if (row.PublicNotes) {
                res = row.PublicNotes.replace(/\\par[d]?/g, '')
              }
              return res.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '').trim()
            }
          },
          {
            label: 'HR Notes',
            value: row => {
              let res = ''
              if (row.HRNotes) {
                res = row.HRNotes.replace(/\\par[d]?/g, '')
              }
              return res.replace(/\{\*?\\[^{}]+}|[{}]|\\\n?[A-Za-z]+\n?(?:-?\d+)?[ ]?/g, '').trim()
            }
          },
          {
            label: 'Position',
            value: 'Status'
          },
          {
            label: 'Position From Date',
            value: row => new Date(row.Status_From_Date).toISOString().substring(0, 10)
          },
          {
            label: 'Supervisor',
            value: row => row.Supervisor_Full_Name === '[ ]' ? '' : row.Supervisor_Full_Name
          },
          {
            label: 'Mentor',
            value: row => row.Mentor_Full_Name === '[ ]' ? '' : row.Mentor_Full_Name
          },
          {
            label: 'Department',
            value: 'Department'
          },
          {
            label: 'Contract Type',
            value: 'Contract_Type'
          },
          {
            label: 'Work Location',
            value: 'Work_Location_Type'
          },
          {
            label: 'Birth',
            value: row => row.Birth ? new Date(row.Birth).toISOString().substring(0, 10) : ''
          },
          {
            label: 'Hiring Date',
            value: row => new Date(row.Hiring_Date).toISOString().substring(0, 10)
          },
          {
            label: 'Left Date',
            value: row => row.Left_Date ? new Date(row.Left_Date).toISOString().substring(0, 10) : ''
          },
          {
            label: 'Years of Work',
            value: 'WorkDuration_YearPart'
          },
          {
            label: 'Months of Work',
            value: 'WorkDuration_MonthPart'
          },
          {
            label: 'Previous Experience',
            value: 'Previous_Experience'
          },
          {
            label: 'Total Experience',
            value: row => {
              if (!row.Total_Experience) return '0 months'

              const totalYearsDecimal = parseFloat(row.Total_Experience)

              let years = Math.floor(totalYearsDecimal)
              let months = Math.round((totalYearsDecimal - years) * 12)

              if (months === 12) {
                years += 1
                months = 0
              }

              const getYearText = (num) => (num === 1 ? 'year' : 'years')

              const getMonthText = (num) => (num === 1 ? 'month' : 'months')

              const yearPart = years > 0 ? `${years} ${getYearText(years)}` : ''
              const monthPart = months > 0 ? `${months} ${getMonthText(months)}` : ''

              if (yearPart && monthPart) {
                return `${yearPart} and ${monthPart}`
              }
              return yearPart || monthPart || '0 months'
            }
          },
          {
            label: 'Rate From Date',
            value: row => new Date(row.Rate_Date).toISOString().substring(0, 10)
          },
          {
            label: 'Rate',
            value: 'Rate'
          },
          {
            label: 'Salary',
            value: 'Salary'
          },
          {
            label: 'Salary Type',
            value: 'Salary_Type'
          }
        ]
        const oldItemsPerPage = this.itemsPerPage
        this.itemsPerPage = -1
        setTimeout(() => {
          const currentDisplayedEmpl = this.$refs.employee_table.selectableItems.map(e => e.Employee_ID)
          const data = [
            {
              sheet: 'Employee',
              columns: columns,
              content: res.data.filter(e => currentDisplayedEmpl.indexOf(e.Employee_ID) > -1)
            }
          ]
          this.itemsPerPage = oldItemsPerPage
          xlsxExport(data, { fileName: 'Employee' })
        })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    updateCurrentCount (e) {
      this.currentCount = e.itemsLength
    },
    showEmployeeOnly (key) {
      for (const itemKey in this.showEmployeeOn) {
        if (key === itemKey) this.showEmployeeOn[itemKey] = !this.showEmployeeOn[itemKey]
        else this.showEmployeeOn[itemKey] = false
      }
    },
    getEmployeeList () {
      this.axios.get('/api/employeelist', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setEmployeeList', { employeeList: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getContractTypes () {
      this.axios.get('/api/contract_type', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setContractTypes', { contractTypes: res.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getWorkLocations () {
      this.axios.get('/api/work_locations', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setWorkLocations', { locations: res.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getDepartments () {
      this.axios.get('/api/department', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setDepartments', { departments: res.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    async getPermissions () {
      await this.axios.get('/api/permissions/0', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setPermissions', { permissionsFor: 'employee', permissions: res.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    addNewEmployee () {
      this.editEmployee = true
      this.getEmployeeDetails()
    },
    itemClass (item) {
      return item.Is_Deleted ? 'red lighten-5' : ''
    },
    getStatuses () {
      this.axios.get('/api/employee_status', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setStatuses', { statuses: res.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    onCloseDetails () {
      this.selectedEmployee = null
      this.editEmployee = false
    },
    getEmployee () {
      this.axios.get('/api/employee', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.setEmployeeList(0, res.data)
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response ? error.response.data : '' })
      })
    },
    setEmployeeList (beginNumber, employee) {
      const empl = []
      for (let i = beginNumber; i < beginNumber + 100; i++) {
        if (employee[i]) {
          empl.push(employee[i])
        } else {
          break
        }
      }
      if (empl.length) this.$store.dispatch('addEmployee', { employee: empl })
      setTimeout(() => {
        this.setEmployeeList(beginNumber + 100, employee)
      })
    },
    onRowClick (e) {
      this.getEmployeeDetails(e.Employee_ID)
    },
    getEmployeeDetails (id) {
      if (id) {
        this.axios.get('/api/employee/' + id, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.selectedEmployee = {
            ...this.selectedEmployee,
            ...res.data[0]
          }
          this.oldLogin = res.data[0].Login
          this.$store.dispatch('updateEmployee', { employee: this.selectedEmployee })
          this.showDetails = true
          this.detailsUpdateKey++
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        const hiringDate = new Date()
        const endOfTrialPeriodDate = new Date(hiringDate.getTime())
        endOfTrialPeriodDate.setMonth(hiringDate.getMonth() + 1)

        this.selectedEmployee = {
          Login: null,
          Last_Name: null,
          Name: null,
          Subname: null,
          Birth: null,
          ZIP: null,
          City: null,
          Address: null,
          Home_Phone: null,
          Work_Phone: null,
          Cellular: null,
          e_mail: null,
          Supervisor_ID: this.employeeList[0].employee_id,
          Mentor_ID: null,
          Balance: 0,
          Employee_IM: [],
          Is_Deleted: false,
          Deleted_Notes: null,
          Photo: null,
          Dep_ID: this.departments[0].Dep_ID,
          Hiring_Date: hiringDate,
          Left_Date: null,
          PublicNotes: null,
          HRNotes: null,
          Working_Hours: null,
          Contract_Type_Code: this.contractTypes[0].Code,
          Work_Location_Type_Code: this.workLocations[0].Code,
          End_Of_Trial_Period_Date: endOfTrialPeriodDate.toISOString().substr(0, 10)
        }
        this.showDetails = true
      }
    },
    goTo () {
      this.$vuetify.goTo(
        '.data-table tbody tr',
        {
          offset: 50,
          container: '.v-data-table__wrapper'
        }
      )
    },
    createNewEmployee (e) {
      this.axios.post('/api/employee', e, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Employee successfully created' })
        this.editEmployee = false
        this.$store.dispatch('addEmployee', { employee: res.data })
        this.onRowClick(res.data[0])
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    updateEmployee (e) {
      this.axios.put('/api/employee/' + e.Employee_ID, {
        ...e,
        Old_Login: this.oldLogin
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('setSuccess', { successMsg: 'Employee successfully updated' })
        this.editEmployee = false
        this.getEmployeeDetails(res.data[0].Employee_ID)
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    getUserPosition () {
      this.axios.get(`/api/get_user_position/${this.user.employee_id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setCurrentUserPosition', { employeePosition: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    exportMilitaryInfoToXLSX () {
      this.axios.get('/api/employee_military_xlsx', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        },
        responseType: 'blob'
      }).then(result => {
        const url = window.URL.createObjectURL(new Blob([result.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `MilitaryInfo_${new Date().toISOString().substr(0, 10)}.xlsx`)
        document.body.appendChild(link)
        link.click()
      })
    }
  },
  filters: {
    dateFilter (val) {
      if (!val) return ''
      const d = new Date(val)
      if (isNaN(d.getTime())) return ''
      return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`
    }
  }
}
</script>

<style lang="scss" scoped>
  @media screen and (max-width: 480px) {
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
      font-size: 16px;
    }
  }
.theme--light .headline {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}
.theme--dark .headline {
  background-color: #424242 !important;
  color: #fff !important;
}
</style>
